import { Component, Input, OnInit } from '@angular/core';
import { Cloudinary, XmStore, XmStoreUtil } from 'core/services';
import { CmsCore } from 'store/cms/models';
import { Subscription } from 'rxjs';
import { FCC_BROADBAND_FOOTER } from 'my-account/constants';

@Component({
    selector: 'xm-fcc-card',
    styleUrls: ['./fcc-card.scss'],
    templateUrl: './fcc-card.html',
    standalone: false
})
export class XmFccCardComponent implements OnInit {
    @Input() public page: string;
    public expanded: boolean = false;
    public imageOptions: MediaImageOptions;
    public footerText: string = FCC_BROADBAND_FOOTER.READ_MORE;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];

    constructor( xmStore: XmStore) {
        Object.assign(this, { xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsCore>(CmsCore), (result: CmsCore) => {
            this.imageOptions = { mobile: Cloudinary.generateMediaFromCms(result.nav.caretIcon) };
        }));
    }

    public toggleSection(el: HTMLElement): void {
        this.expanded = !this.expanded;
        this.footerText = this.expanded ? FCC_BROADBAND_FOOTER.READ_LESS : FCC_BROADBAND_FOOTER.READ_MORE;
        if (!this.expanded) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
    }
}
